import React from "react";
import styled from "styled-components";

export default () => (
  <Wrap>
    <Section
      title="Why are our insiders anonymous?"
      text="Anonymity allows our Insiders to give honest and nitty-gritty details about their job, routine, company culture, and more."
    />
    <Section
      title="What happens during the call?"
      text="You are guaranteed a friendly conversation with a current or former employee of the specific team & company you choose. Our insiders will spend a minimum of 30 minutes fulfilling your selected objectives for the call. All of our insiders are committed to making the call as valuable to you as possible."
    />
    <Section
      title="Money Back Guarantee"
      text="We know you’ll love our insiders, but if you are unsatisfied with your call we are happy to provide a full refund within 30 days. "
    />
  </Wrap>
);

const Wrap = styled.div`
  width: 25.625rem;
  margin-left: 3.75rem;
  flex-shrink: 0;
  @media (max-width: 768px) {
    width: 100%;
    margin-left: 0;
  }
`;

const Box = styled.div`
  background-color: #ebe8e1;
  border-top: 8px solid #000000;
  font-size: 21px;
  margin-bottom: 1rem;
  color: #333333;
  padding: 2.6rem 2rem;
  font-family: CircularStd-Book, sans-serif;
  @media (max-width: 680px) {
    border: unset;
    background: #f9f7f2;
    display: none;
  }
`;

const Title = styled.div`
  font-size: 1.25rem;
  margin-bottom: 1.125rem;
  font-family: "CircularStd-Book", sans-serif;
`;

const Text = styled.div`
  font-family: "CircularStd-Book", sans-serif;
  color: #b0b0b0;
`;

const Section = ({ title, text }) => (
  <Box>
    <Title>{title}</Title>
    <Text>{text}</Text>
  </Box>
);



// WEBPACK FOOTER //
// ./src/components/common/candidate/ScheduleCall/components/Sidebar/index.js